const Form051SC = {
    stepName: {
        importantNotes: "重要提示",
        applicantInformation: "申请人资料",
        confirmation: "确认",
    },
    title: {
        applicantInformation: "申请人资料",
        applicantNotePoints: "申请人须知",
        completedApplicant1: `此栏由申请人填写`,
        completedApplicant2: `如选择以平邮寄回报告复本，请在下面用正楷写上收件人姓名及本地邮寄地址。`,
        // completedApplicant3: `请在下面用正楷写上收件人姓名及本地邮寄地址。 `,
        completedByEDB: "此栏由教育局填写",
    },
    note: {
        note1: `(1)	申请人如欲索取听力报告的复本，请填妥本表格并上载所需的证明文件。`,
        note2: `(2)	申请人须年满十八岁。`,
        note3: `(3)	如申请人拒绝提供所需的资料或所提供的资料不正确，教育局将无法提供所需服务。`,
        note4: `(4)	个人资料使用声明：申请人在此表格上所提供的资料，将用作核实与此要求有关的资料及其他与之直接有关的用途。`,
        note4ii:
            "(4) 个人资料收集声明：教育局会使用本表格所载的个人资料，作核实你要求索取听力报告的复本及其他与之直接有关的用途。",

        note5: `(5)	如有疑问，请向教育局教育听力服务组查询（电话：3698 3909）。`,
        note6: `报告复本备妥后，请用以下方法交予本人（请选择其中`,
        note7: "致申请人：",
        note8: "现附上听力报告复本共",
        note9: "页，敬请查收。",
        note10: "如有疑问，请联络教育局教育听力服务组（电话：3698 3909）。",
        note11: "一项",
        note12: ")：",
    },
    label: {
        identityOption: {
            aboveStudent: {
                aboveStudent1: "本人是",
                aboveStudent2: "本人的身份证明文件影印本",
                aboveStudent3: "，以向教育局索取本人的听力报告复本一份。",
                aboveStudent4: "上述学生",
                aboveStudent5: "，现夹附",
            },
            aboveStudentParent: `本人是上述学生的`,
            aboveStudentGuardian: {
                text1: `本人是上述学生的`,
                text2: `监护人`,
                text3: `(与学生的关系：`,
            },
        },
        relationshipMsg: "关系",
        aboveStudentParentOption: {
            father: "父亲",
            mother: "母亲",
        },
        aboveStudentParentOptions: {
            aboveStudentFather: `父亲`,
            aboveStudentMother: `母亲`,
        },
        aboveStudentGuardianOption: {
            aboveStudentGuardianFather: `上述学生的`,
            aboveStudentGuardianMother: `其他证明文件的影印本`,
        },
        aboveStudentGuardianOptions: {
            aboveStudentGuardianFather: `父亲`,
            aboveStudentGuardianMother: `母亲`,
        },
        aboveStudentiDentityCardOptions: {
            informMe: `通知本人亲身领取`,
            mailMe: `用平邮寄给本人(请填上收件人姓名及本地邮寄地址)`,
        },
        identityTypeOption: {
            HKIDCard: "香港身份证",
            passport: "护照",
            permit: "往来港澳通行证",
        },
        aboveStudentParentEnd: `，`,
        aboveStudentParentEnd1: {
            text1: "现夹附(1)",
            text2: "本人的身份证明文件影印本",
            text3: "及(2)",
            text4: "上述学生的出生证明文件或其他证明文件影印本",
            text5: "，以示本人为上述学生的家长，以向教育局索取上述学生的听力报告复本一份。",
        },
        aboveStudentGuardianEnd: {
            text1: "现夹附(1)",
            text2: "本人的身份证明文件影印本",
            text3: "、(2)",
            text4: "上述学生的出生证明文件或其他证明文件影印本",
            text5: "及(3)",
            text6: "以下的证明文件",
            text7: "，以示本人为上述学生的监护人，以向教育局索取上述学生的听力报告复本一份",
        },
        guardianParentChoiceEnd: "的身份证明文件影印本",
        studentEnName: "学生姓名（英文）",
        studentCnName: "学生姓名（中文）",
        studentNameMsg: "学生姓名",
        birthDate: "出生日期",
        identityNo: "身份证明文件号码",
        identityNoMsg: "身份证明文件号码",
        issuedDate: `所要求的报告的大概发出日期或年份：(如没有注明，则设定为教育局记录上最近期的听力报告。) `,
        applicantName: "学生姓名",
        applicantSignature: "申请人签署",
        identityDocumentNo: "身份证明文件号码",
        identityDocumentType: "身份证明文件类别",
        identityDocumentMsg: "身份证明文件号码",
        contactTelephone: "本地日间联络电话",
        telephoneNumber: "电话号码",
        otherDocument: "证明文件",
        date: "日期",
        name: "收件人",
        address: "本地邮寄地址",
        page: "页数",
    },
    errorMsg: {
        englishNameRule:
            "请输入正确的规则（字符类型（仅字母/字母数字/仅中文）和特殊字符为逗号(,)、空格( )、加号(+)、哈希(#)、括号(()) 和连字符 (-).)",
        rule: "请输入正确的规则（字符类型（仅限字母/字母数字/仅限中文））",
        telMsg: "电话号码必须为最多8位数",
        nameMsg: "请输入一个有效的收件人姓名",
        attachedFile: "你的身份证明文件影印本",
        parentAttachedFile:
            "你的身份证明文件影印本以及上述学生的出生证明文件或其他证明文件影印本",
        studentRelationship: "与学生的关系",
        otherDocumentTemp: "其他证明文件的资料",
        otherDocument: "其他证明文件的影印本",
        relationshipRequired: "请选择关系",
        guardianChoiceRequired: "请选择文件类型",
        identityCardChoiceRequired: "请选择方法",
        identityChoiceRequired: "请选择身份证明文件类型",
        name: "收件人姓名",
        address: "本地邮寄地址",
        identityNo: "身份证明文件号码",
    },
};
export default Form051SC;
